module.exports = __webpack_public_path__ + "img/Bodice-Back-Jc-fabric straps-Ka-La.3bc00ccb.png";